import { forwardRef, PropsWithChildren, ReactNode } from 'react';

import { Tooltip, TooltipProps } from '@components/primitives/Tooltip';
import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface DefinitionProps extends PropsWithChildren {
  className?: string;
  content: ReactNode;
  side?: TooltipProps['side'];
  align?: TooltipProps['align'];
  sideOffset?: TooltipProps['sideOffset'];
  alignOffset?: TooltipProps['alignOffset'];
}

export const Definition = forwardRef<HTMLSpanElement, DefinitionProps>(
  function Definition(
    {
      children,
      className,
      content,
      side = 'top',
      align = 'center',
      sideOffset,
      alignOffset,
      ...props
    },
    ref
  ) {
    return (
      <Tooltip
        content={<div className={css.tooltip}>{content}</div>}
        interactive
        side={side}
        align={align}
        sideOffset={sideOffset}
        alignOffset={alignOffset}
      >
        <span ref={ref} className={cn(css.definition, className)} {...props}>
          {children}
        </span>
      </Tooltip>
    );
  }
);
